import { render, staticRenderFns } from "./InfoBlock.vue?vue&type=template&id=4ef2ed87&scoped=true&"
import script from "./InfoBlock.vue?vue&type=script&lang=js&"
export * from "./InfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./InfoBlock.vue?vue&type=style&index=0&lang=less&"
import style1 from "./InfoBlock.vue?vue&type=style&index=1&id=4ef2ed87&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef2ed87",
  null
  
)

export default component.exports